import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { useCallback, useMemo } from 'react';
export const useAskInputExhaustedSearchMode = ({ enabled = true, showSearchModeMenu, }) => {
    const { exhaustedSearchMode, setExhaustedSearchMode } = useThreadConfig();
    const onClearExhaustedMode = useCallback(() => {
        setExhaustedSearchMode(undefined);
    }, [setExhaustedSearchMode]);
    return useMemo(() => {
        if (enabled && exhaustedSearchMode && !showSearchModeMenu) {
            return {
                showExhaustedSearchMode: true,
                exhaustedSearchMode,
                onClearExhaustedMode,
            };
        }
        return { showExhaustedSearchMode: false };
    }, [enabled, exhaustedSearchMode, onClearExhaustedMode, showSearchModeMenu]);
};
//# sourceMappingURL=useAskInputExhaustedSearchMode.js.map